module.exports = __webpack_public_path__ + "img/exam (4).2c69607a.png";